import React from 'react';
import { useGetUsers } from 'services/2n/get-all-users';
import { useGetZones } from 'services/2n/zones';
import { FilterModal } from 'components/modals/FilterModal';
import { categoryOptions, columnOptions, credentialsOptions, operatorOptions } from './constants';

export const AccessLogsFilterModal = ({ isOpen, onClose, currentFilter, onApply }) => {
  const { users } = useGetUsers();
  const { zones } = useGetZones();

  const userOptions = (users || []).map((u) => ({
    key: u.Id || u.Name,
    text: u.Name,
    value: u.Id || u.Name,
  }));

  const zoneOptions = (zones || []).map((g) => ({
    key: g.Id || g.Name,
    text: g.Name,
    value: g.Id || g.Name,
  }));

  const dropdownOptionsMap = {
    user: userOptions,
    category: categoryOptions,
    zone: zoneOptions,
    credentials: credentialsOptions,
  };

  const dropdownColumns = ['user', 'category', 'zone', 'credentials'];

  return (
    <FilterModal
      isOpen={isOpen}
      onClose={onClose}
      currentFilter={currentFilter}
      onApply={onApply}
      columnOptions={columnOptions}
      operatorOptions={operatorOptions}
      dropdownOptionsMap={dropdownOptionsMap}
      dropdownColumns={dropdownColumns}
      headerTitle="Filter Access Logs"
    />
  );
};

